import React, { useEffect } from 'react';
import AppRoutes from './routes/routes_main';
import AuthProvider from './auth/AuthProvider';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import { preloadWelcomeAssets } from './utils/preloader';

function App() {
  // # Preload welcome assets when app starts
  useEffect(() => {
    const preloadAssets = async () => {
      // # Check if assets are already preloaded in this session
      if (!sessionStorage.getItem('welcomeAssetsPreloaded')) {
        await preloadWelcomeAssets();
      }
    };

    preloadAssets();
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <div className="app">
          <AppRoutes />
        </div>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
